import { loadJSView, loadReactView } from './loadView';

// JS Views
const checkoutSlider = loadJSView('orders/checkoutSlider');

const orderViews = {
  checkoutSlider,
};

export default orderViews;
